module.exports = __webpack_public_path__ + "static/media/image_orange.149ec57e.png";